import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { MAINTENANCE_URL } from '../../../constants/app-url-constants';
import { MaintenanceService } from '../services/maintenance.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate, CanActivateChild {
  constructor(private service: MaintenanceService, private router: Router){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
     return this.checkMaintenanceStatus();
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.checkMaintenanceStatus();
  }


  checkMaintenanceStatus(){
    return this.service.getMaintenanceStatus().pipe(
      map(data => {
        if (data.message === 'true') {
          this.router.navigate([MAINTENANCE_URL]);
          return false;
        }
        return true;
      }),
      catchError(() => this.router.navigate(['/']))
    );
  }
}
